import { IProduct } from "../Models/IProduct";
import BasketStore from "../Stores/BasketStore";

export function getBasketQuantity(Product: IProduct):string {
    const quantity = BasketStore.getBasket().find((b) => b.product == Product?.productId)?.quantity
    return quantity?.toString() ?? "0"
}